import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import styled from 'styled-components';
import BreadcrumbHandler from '../../layout/components/breadcrumb/BreadcrumbHandler';
import colors from '../../constants/colors';
import ModuleWidgetSwitch from '../../layout/screenSpecifics/ModuleSelect/ModuleWidgetSwitch';
import { axiosPath } from '../../routing/helpers/router';
import ModuleSelectMapBlock from '../../layout/screenSpecifics/ModuleSelect/ModuleSelectMap/ModuleSelectMapBlock';
import errorHandler from '@/layout/components/error/ErrorHandler';
import AppRedirectToModule from '../../routing/helpers/AppRedirectToModule';
import useIsMounted from '../../layout/components/hooks/useIsMounted';
import { AppNoInfo } from '@/layout/AppComponents';

const ModuleSelectScreen = () => {
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [modules, setModules] = useState();

  // > LOAD MODULES
  const loadModuleList = useCallback(async () => {
    setModules(null);
    await axios
      .post(axiosPath("api_r_user_authUser_getModuleList"))
      .then((r) => {
        if (isMounted.current) {
          setModules(r?.data);
        }
      })
      .catch((e) => dispatch(errorHandler(e)));
  }, []);

  useEffect(() => {
    loadModuleList();
  }, []);
  // < LOAD MODULES

  if (!modules) {
    return (
      <div style={{ marginTop: '200px' }}>
        <AppNoInfo />
      </div>
    );
  }

  if (
    modules?.userModules.length === 1 &&
    modules?.userModules[0]?.name !== 'ModuleBridgeFolder'
  ) {
    return <AppRedirectToModule userModule={modules?.userModules[0]} />;
  }

  return (
    <div className="relative m_sr">
      <>
        <BreadcrumbHandler paths={[]} />
      </>
      {modules?.map && <ModuleSelectMapBlock map={modules?.map} />}

      <ModuleContainer>
        <SquareContainer>
          <div className="grid">
            <div>
              <ModuleWidgetSwitch />
            </div>
            {modules.userModules.map((module) => (
              <div
                key={module.hex}
                // style={
                //   module.card?.width
                //     ? { gridColumn: `span ${module.card?.width}` }
                //     : {}
                // }
              >
                <ModuleWidgetSwitch type={module.name} module={module} />
              </div>
            ))}
          </div>
        </SquareContainer>
      </ModuleContainer>
    </div>
  );
};

export default ModuleSelectScreen;

const SquareContainer = styled.div`
.grid{
  display: grid;
  grid-template-columns: repeat(auto-fill, 200px);
  grid-auto-rows: 250px;
  column-gap: 40px;
  row-gap: 40px;
}
.grid::before {
  content: '';
  width: 0;
  padding-bottom: 100%;
  grid-row: 1 / 1;
  grid-column: 1 / 1;
}

.grid > *:first-child {
  grid-row: 1 / 1;
  grid-column: 1 / 1;
}



/* Just to make the grid visible */

// .grid > * {
//   //background: rgba(0,0,0,0.1);
//   border: 1px  ${colors.primaryLight} solid;
// }
// .grid-header{
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   width: 200px;
//   height: 200px;
// }
// .grid-title{
//   display: flex;
//  
//   width: 199px;
//   height: 50px;
//   background: ${colors.primary};
//   p{
//     margin: 6px 10px;
//     text-align: center;
//     height: 35px;
//     width: 180px;
//     vertical-align: middle;
//     color: white;
//     font-size: 11px;
//     font-weight: bold;
//     text-transform: uppercase;
//     display: -webkit-box;
//     -webkit-line-clamp:2 ;
//     -webkit-box-orient: vertical;
//     overflow: hidden;
//     text-overflow: ellipsis;
//   }
//  
// }
  
`;
const ModuleContainer = styled.div`
  margin: 10px 5%;
  h1 {
    font-size: 20px;
    color: ${colors.primary};
    margin: 10px 0;
  }
  img {
    max-width: 100%;
    max-height: 100%;
  }
  .construct {
    padding: 6px;
    border: 2px dashed ${colors.primaryLight};
  }
`;
